import { render } from "./jjcg.vue?vue&type=template&id=c98b0f44&scoped=true&ts=true"
import script from "./jjcg.vue?vue&type=script&lang=ts"
export * from "./jjcg.vue?vue&type=script&lang=ts"

import "./jjcg.vue?vue&type=style&index=0&id=c98b0f44&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98b0f44"]])

export default __exports__